export default __webpack_public_path__ + "static/media/smartneuro.5a316999.svg";